<div class="planthunter__products planthunter__products--summary" [ngClass]="{loading: loading()}">
  <div class="overview-grid overview-grid--planthunter"
    [ngClass]="{'grid-spacing-start': planthunterProductList().length < 4}">
    @for (product of getShowAmountOfProducts(); track product) {
      <product-item-grid #productItemGridComponent
        class="overview-product"
        [product]="product"
        [planthunterId]="planthunter.planthunterFeature"
        (viewProductDetailClickEvent)="viewProductDetail($event)"
        (lazyLoad)="productItemGridComponent.doLoad($event)"
        [loggedIn]="isUserLoggedin()">
      </product-item-grid>
    }
  </div>
</div>

@if (!isShowToggleMoreProduct()) {
  <div class="planthunter__show-all">
    @if (!showAllProducts()) {
      <button type="button"
        class="button--text underline"
        (click)="toggleShowMorePlanthunterProducts(planthunter.planthunterFeature)"
        i18n="Planthunter show all hunts@@planthunter.show.hunts">
		Show all {{planthunter.firstName}}'s hunts
	</button>
    }
    @if (showAllProducts()) {
      <button type="button"
        class="button--text underline"
        (click)="toggleShowMorePlanthunterProducts(planthunter.planthunterFeature)"
        i18n="Planthunter show less hunts@@planthunter.show.less.hunts">
		Show less of {{planthunter.firstName}}'s hunts
	</button>
    }
  </div>
}
